import Axios from 'axios';

function createLinkToDownload(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('type', 'hidden');
  link.setAttribute('download', fileName);
  link.setAttribute('href', url);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export default {
  getBillPaymentsOfBill(BillId) {
    return Axios.get('/admin/bill_payments', {
      params: {
        bill_id: BillId,
      },
    })
      .then(({ data }) => data);
  },
  downloadBoleto(billPaymentId) {
    return Axios
      .get(`/admin/bill-payments/${billPaymentId}/download-boleto`, { responseType: 'blob' })
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        // prevent IE download attribute error
        if ('msSaveOrOpenBlob' in window.navigator) {
          return window.navigator.msSaveOrOpenBlob(blob, `Fatura - ${String(billPaymentId)}`);
        }
        return createLinkToDownload(blob, `Fatura - ${String(billPaymentId)}`);
      });
  },
  refundPayment(billPaymentId, bankAccountParams) {
    return Axios.post(`/admin/bill-payments/${billPaymentId}/refund`, { bank_account: bankAccountParams })
      .then(({ data }) => data);
  },
  refundPaymentManually(billPaymentId) {
    return Axios.post(`/admin/bill-payments/${billPaymentId}/manually-refund`).then(({ data }) => data);
  },
  transferPayment(billId, billPaymentId, chainNewBill) {
    return Axios.put(`/admin/bill-payments/${billPaymentId}/transfer-payment`, {
      bill_id: billId,
      chain: chainNewBill,
    })
      .then(({ data }) => data);
  },
};
